"use client";

import type { FC, Ref } from "react";
import { Flex } from "@huub-web/ui/components/Flex";
import { Text } from "@huub-web/ui/components/Text";

import { TemplatesParser } from "../../components";
import type { TemplateCollection } from "../../types";

export interface ListTemplateProps {
  /**
   * The templates to render within the list
   */
  templates: TemplateCollection;
  /**
   * The title of the list
   */
  title?: string;
  /**
   * The description of the list
   */
  description?: string;
}

/**
 * A template that renders child templates in a flexible list layout
 */
export const ListTemplate: FC<
  ListTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, title, description, ref }) => (
  <Flex direction="column" gap="m">
    {(title || description) && (
      <Flex direction="column" gap="xs">
        <Text as="h3" variant="displayS" bold>
          {title}
        </Text>
        {description && (
          <Text as="p" variant="bodyS" color="currentColor50">
            {description}
          </Text>
        )}
      </Flex>
    )}
    <Flex ref={ref} direction="column" gap="m">
      <TemplatesParser templates={templates} level={1} />
    </Flex>
  </Flex>
);
